import { Nullable } from '@clearverify/types';

import { EmployerWhere, PlatformStaffItemFragment } from 'src/api';

export const buildPlatformStaffVisibilityFilter = (
  platformStaff: Nullable<PlatformStaffItemFragment>,
): EmployerWhere => {
  const visibleEmployersIds = platformStaff?.employersVisibleList.map(item => item.id) || [];

  const hiddenEmployersIds = platformStaff?.employersVisibleList.map(item => item.id) || [];

  if (visibleEmployersIds.length > 0) {
    return {
      id: {
        in: visibleEmployersIds,
      },
    };
  }

  if (hiddenEmployersIds.length > 0) {
    return {
      id: {
        notIn: hiddenEmployersIds,
      },
    };
  }

  return {};
};

export const buildPlatformStaffVisibilityByEmployerFilter = (
  platformStaff: Nullable<PlatformStaffItemFragment>,
): { employer: EmployerWhere } => {
  return {
    employer: buildPlatformStaffVisibilityFilter(platformStaff),
  };
};
